export const GAMES_LIST = {
  "Board & Puzzle Games": [
    {
      "id": 1,
      "title": "Tic Tac Toe",
      "slug": "tic-tac-toe",
      "image": "https://upload.wikimedia.org/wikipedia/commons/3/32/Tic_tac_toe.svg",
      "description": "A classic two-player game where you aim to place three of your marks in a horizontal, vertical, or diagonal row.",
      "difficulty": "Easy",
      "playtime": "2-5 mins"
    },
    {
      "id": 2,
      "title": "Sudoku",
      "slug": "sudoku",
      "image": "https://upload.wikimedia.org/wikipedia/commons/e/e0/Sudoku_Puzzle.svg",
      "description": "A number puzzle game where the objective is to fill a 9x9 grid so that each column, each row, and each of the nine 3x3 subgrids contain all of the digits from 1 to 9.",
      "difficulty": "Medium",
      "playtime": "10-30 mins"
    },
    {
      "id": 3,
      "title": "Minesweeper",
      "slug": "minesweeper",
      "image": "https://upload.wikimedia.org/wikipedia/commons/e/e5/Minesweeper_Icon.png",
      "description": "A single-player puzzle game where you clear a rectangular board containing hidden mines without detonating any of them.",
      "difficulty": "Medium",
      "playtime": "5-15 mins"
    },
    {
      "id": 4,
      "title": "2048",
      "slug": "2048",
      "image": "https://upload.wikimedia.org/wikipedia/commons/1/18/2048_logo.svg",
      "description": "A single-player sliding block puzzle game where you combine tiles with the same number to reach the 2048 tile.",
      "difficulty": "Easy",
      "playtime": "5-10 mins"
    },
    {
      "id": 5,
      "title": "Matching Tiles",
      "slug": "matching-tiles",
      "image": "https://upload.wikimedia.org/wikipedia/commons/6/6d/Memory_game.svg",
      "description": "A memory game where you flip over tiles to find matching pairs.",
      "difficulty": "Easy",
      "playtime": "5-10 mins"
    }
  ],
  "Arcade & Casual Games": [
    {
      "id": 1,
      "title": "Snake Game",
      "slug": "snake-game",
      "image": "https://upload.wikimedia.org/wikipedia/commons/0/07/Snake_game_play.png",
      "description": "Control a snake to eat food and grow longer without hitting the walls or your own tail.",
      "difficulty": "Easy",
      "playtime": "5-10 mins"
    },
    {
      "id": 2,
      "title": "Brick Breaker",
      "slug": "brick-breaker",
      "image": "https://upload.wikimedia.org/wikipedia/commons/3/3d/Brick_Breaker_Game.png",
      "description": "A breakout clone where you use a paddle to bounce a ball and break bricks.",
      "difficulty": "Medium",
      "playtime": "10-20 mins"
    },
    {
      "id": 3,
      "title": "Flappy Bird Clone",
      "slug": "flappy-bird-clone",
      "image": "https://upload.wikimedia.org/wikipedia/commons/7/7a/Flappy_Bird_Logo.png",
      "description": "Navigate a bird through obstacles by tapping to keep it in the air.",
      "difficulty": "Hard",
      "playtime": "2-5 mins"
    },
    {
      "id": 4,
      "title": "Dino Run",
      "slug": "dino-run",
      "image": "https://upload.wikimedia.org/wikipedia/commons/8/8e/Dino_Run_Game.png",
      "description": "A running game where you control a dinosaur and avoid obstacles.",
      "difficulty": "Medium",
      "playtime": "5-10 mins"
    }
  ],
  "Strategy & Logic Games": [
    {
      "id": 1,
      "title": "Tower Defense",
      "slug": "tower-defense",
      "image": "https://upload.wikimedia.org/wikipedia/commons/4/4e/Tower_Defense_Game.png",
      "description": "A strategy game where you prevent enemies from reaching your base by building defensive towers.",
      "difficulty": "Hard",
      "playtime": "20-40 mins"
    },
    {
      "id": 2,
      "title": "Chess",
      "slug": "chess",
      "image": "https://upload.wikimedia.org/wikipedia/commons/3/30/ChessStartingPosition.jpg",
      "description": "A strategic board game where two players aim to checkmate the opponent's king.",
      "difficulty": "Hard",
      "playtime": "30-60 mins"
    },
    {
      "id": 3,
      "title": "Reversi (Othello)",
      "slug": "reversi-othello",
      "image": "https://upload.wikimedia.org/wikipedia/commons/3/3c/Reversi_Game.png",
      "description": "A strategy board game where players aim to have the majority of disks turned to display their color when the last playable empty square is filled.",
      "difficulty": "Medium",
      "playtime": "15-30 mins"
    }
  ],
  "Card & Casino Games": [
    {
      "id": 1,
      "title": "Solitaire",
      "slug": "solitaire",
      "image": "https://upload.wikimedia.org/wikipedia/commons/4/4b/Solitaire_Game.png",
      "description": "A card game where the goal is to move all cards to foundation piles in ascending order by suit.",
      "difficulty": "Easy",
      "playtime": "10-20 mins"
    },
    {
      "id": 2,
      "title": "Poker",
      "slug": "poker",
      "image": "https://upload.wikimedia.org/wikipedia/commons/5/5b/Poker_Game.png",
      "description": "A popular card game that combines gambling, strategy, and skill.",
      "difficulty": "Hard",
      "playtime": "30-60 mins"
    }
  ],
  "Multiplayer Games": [
    {
      "id": 1,
      "title": "Ludo",
      "slug": "ludo",
      "image": "https://upload.wikimedia.org/wikipedia/commons/3/3e/Ludo_Game.png",
      "description": "A classic board game for 2-4 players where each player races their tokens from start to finish according to the rolls of a single die.",
      "difficulty": "Easy",
      "playtime": "20-40 mins"
    },
    {
      "id": 2,
      "title": "Rock Paper Scissors",
      "slug": "rock-paper-scissors",
      "image": "https://upload.wikimedia.org/wikipedia/commons/0/0a/Rock_Paper_Scissors_Game.png",
      "description": "A simple hand game played between two people, where each player simultaneously forms one of three shapes with an outstretched hand.",
      "difficulty": "Easy",
      "playtime": "1-2 mins"
    }
  ]
};



export const FALLBACK_IMAGE = "";
